// extracted by mini-css-extract-plugin
export var info = "style-module--info--a9fc9";
export var screen1 = "style-module--screen1--56a9e";